import React from 'react'

const Loading = () => {
  return (
    <div className='size-full flex items-center justify-center'>
      <img
        className="w-16"
        src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/loading-propi.gif"
        alt="loading"
      />
    </div>
  )
}

export default Loading;

/* 
    Componente que muestra una animacion de carga

    - Daniel Bonilla Septiembre 2025
*/